/* ===========================================================
   CoCoCreate Flourish Templates + Loader (Shopify Safe)
   =========================================================== */
(function () {
  const path = window.location.pathname || "";
  if (!path.includes("/pages/cococreate-flourish")) return;
  console.log("🪴 Flourish templates active on:", path);

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(() => {
    const board =
      document.getElementById("board") ||
      document.querySelector('[id*="board"]') ||
      document.querySelector('[id*="workspace"]');

    console.log("✅ Workspace check:", !!document.getElementById("workspace"));
    console.log("✅ Board check:", !!board);

    if (!board) return console.warn("⚠️ No #board found. Templates disabled.");

    const select = document.getElementById("templateSelect");
    if (select) {
      select.addEventListener("change", handleTemplateInsert);
      console.log("🧩 Template selector attached.");
    } else {
      console.warn("⚠️ No #templateSelect found.");
    }
  });

  // ===========================================================
  // Templates
  // ===========================================================
  const templates = {
   

  /* 🏪 Store Launch Announcement */
  storeLaunchBundle: {
    type: "layout",
    name: "Store Launch Bundle",
     tiles: [
      {
        title: "We’re Open! 🌿",
        description: "Welcome to our new shop — handcrafted goods & local favorites.",
        cta_link: "https://yourstore.com",
        goal: "buy"
      },
      {
        title: "🎉 Launch Special",
        description: "Get 10% off your first order — use code HELLO10.",
        image_url: "https://source.unsplash.com/featured/?shopping,celebration",
        goal: "buy"
      },
      {
        title: "💌 Stay in Touch",
        description: "Join our mailing list for early drops & special offers.",
        image_url: "https://source.unsplash.com/featured/?newsletter,hand",
        goal: "subscribe"
      }
    ]
  },

  /* ⚡ Flash Sale Bundle */
  flashSaleBundle: {
    name: "Flash Sale Bundle",
    tiles: [
      {
        title: "🔥 Flash Sale — 48 Hours Only!",
        description: "Everything 20% off. Use code COCO20 at checkout.",
        image_url: "https://source.unsplash.com/featured/?shopping,bags",
        link: "https://yourstore.com/collections/all",
        goal: "buy"
      },
      {
        title: "💌 Early Access",
        description: "Subscribers get first dibs — sign up now.",
        image_url: "https://source.unsplash.com/featured/?newsletter,phone",
        link: "https://mailchi.mp/yourlist/flashsale",
        goal: "subscribe"
      },
      {
        title: "✅ 5-Step Sale Checklist",
        description: "Update banners ✓ Schedule post ✓ Send email ✓ Track sales ✓",
        image_url: "https://source.unsplash.com/featured/?clipboard,marketing",
        link: "https://yourlink.to/flash-checklist.pdf"
      }
    ]
  },

  /* 📦 Inventory Alerts */
  inventoryAlert: {
    name: "Inventory Alerts",
    tiles: [
      {
        title: "⏳ Almost Gone!",
        description: "Only a few left — restock not guaranteed!",
        image_url: "https://source.unsplash.com/featured/?limited,product",
        link: "https://yourstore.com/products/limited-item"
      },
      {
        title: "💥 Back In Stock",
        description: "Your favorite item is back. Grab it before it’s gone again.",
        image_url: "https://source.unsplash.com/featured/?warehouse,restock",
        link: "https://yourstore.com/products/back-in-stock"
      },
      {
        title: "📦 Pre-Order Now",
        description: "Reserve your item in the next drop — ships next week.",
        image_url: "https://source.unsplash.com/featured/?boxes,store",
        link: "https://yourstore.com/products/preorder"
      }
    ]
  },

  /* 🎁 Creator Marketing Pack */
  creatorBundles: {
    name: "Creator Marketing Pack",
    tiles: [
      {
        title: "📣 Announcement Post",
        description: "Promote your pop-up with ready captions + export.",
        image_url: "https://source.unsplash.com/featured/?socialmedia,announcement",
        link: "#generate-instagram-post"
      },
      {
        title: "✉️ Email Draft",
        description: "Quick announcement email — update your link + date.",
        image_url: "https://source.unsplash.com/featured/?email,writing",
        link: "mailto:?subject=New%20Drop%20Live!&body=Shop%20our%20new%20collection:%20https://yourstore.com"
      },
      {
        title: "✅ Pop-Up Checklist",
        description: "Table ✓ QR ✓ Poster ✓ Link ✓ Launch ✓ Celebrate 🎉",
        image_url: "https://source.unsplash.com/featured/?clipboard,checklist",
        link: "https://yourlink.to/launch-checklist.pdf"
      }
    ]
  },

 
    /* === 🏪 Store Launch === */
    storeLaunch: {
      type: "layout",
      name: "Store Launch",
      html: `
        <section class="layout-template store-launch" style="text-align:center; padding:3rem; background:linear-gradient(135deg,#d9f99d,#86efac); border-radius:20px;">
          <h1 contenteditable="true" style="font-size:3rem; font-weight:800; color:#1a2238; margin-bottom:1rem;">We’re Open! 🌿</h1>
          <p contenteditable="true" style="font-size:1.3rem; color:#333; max-width:600px; margin:0 auto 2rem;">Welcome to our brand-new shop — filled with handcrafted goods & local favorites. Tap below to explore our first collection.</p>
          <a href="https://yourstore.com" target="_blank" class="cta" style="background:#1a2238; color:#fff; padding:1rem 2rem; border-radius:10px; font-weight:700; text-decoration:none;">✨ Visit Store</a>
        </section>`
    },

    /* === 🧘 Yoga Welcome === */
    yogaWelcome: {
      type: "layout",
      name: "Yoga Welcome",
      html: `
        <section class="layout-template yoga-layout" style="font-family:'Inter',sans-serif; color:#fff;">
          <div class="yoga-hero" style="position:relative;border-radius:1.5rem;overflow:hidden;height:55vh;">
            <video autoplay muted loop playsinline style="width:100%;height:100%;object-fit:cover;filter:brightness(.6);">
              <source src="https://cdn.shopify.com/videos/c/o/v/1ed683f54bba46389272e7b24bef3be6.mp4" type="video/mp4">
            </video>
            <div class="yoga-overlay" style="position:absolute;inset:0;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;padding:2rem;">
              <h1 contenteditable="true" style="font-size:clamp(2.5rem,6vw,4rem);font-weight:800;margin-bottom:.5rem;">Welcome to Serenity Studio</h1>
              <p contenteditable="true" style="font-size:clamp(1.2rem,2.5vw,1.6rem);margin-bottom:1.5rem;">Find your flow, anywhere, anytime.</p>
              <a href="https://cal.com/yogi/book" target="_blank" class="yoga-cta" style="background:linear-gradient(90deg,#b5f5c4,#89e1b1);color:#0f1220;font-weight:700;padding:.8rem 1.8rem;border-radius:999px;text-decoration:none;box-shadow:0 4px 14px rgba(0,0,0,.2);transition:.2s;">✨ Book Your Intro</a>
            </div>
          </div>
          <div class="yoga-section" style="display:flex;justify-content:center;flex-wrap:wrap;gap:1.5rem;margin-top:2rem;">
            <div class="yoga-card" style="background:rgba(255,255,255,.08);backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.12);border-radius:1rem;padding:1.5rem;width:clamp(260px,30%,340px);text-align:center;transition:.2s;">
              <h2 contenteditable="true">Intro Offer — 1:1</h2>
              <p contenteditable="true">45-minute personalized start (seasonal rate).</p>
              <button onclick="window.open('https://buy.stripe.com/test_c_1on1_intro','_blank')" style="margin-top:.5rem;padding:.6rem 1.2rem;border:none;border-radius:8px;background:#89e1b1;color:#000;font-weight:600;">Buy Now</button>
            </div>
            <div class="yoga-card" style="background:rgba(255,255,255,.08);backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.12);border-radius:1rem;padding:1.5rem;width:clamp(260px,30%,340px);text-align:center;transition:.2s;">
              <h2 contenteditable="true">Join the Newsletter</h2>
              <p contenteditable="true">Get 1 free on-demand class when you subscribe.</p>
              <button onclick="window.open('https://mailchi.mp/yourlist/subscribe','_blank')" style="margin-top:.5rem;padding:.6rem 1.2rem;border:none;border-radius:8px;background:#89e1b1;color:#000;font-weight:600;">Subscribe</button>
            </div>
          </div>
        </section>`
    },

    /* === 🚀 Test Layout (debug) === */
    testLayout: {
      type: "layout",
      name: "Test Layout",
      html: `
        <div style="background:hotpink;color:white;padding:4rem;text-align:center;font-size:2rem;border-radius:20px;">
          🚀 Test Layout Loaded — CoCo is Awake!
        </div>`
    }
  };

  // ===========================================================
  // Template Handler
  // ===========================================================
  window.handleTemplateInsert = function handleTemplateInsert() {
    const select = document.getElementById("templateSelect");
    const type = select?.value?.trim();
    if (!type) return;

    const selected = templates[type];
    if (!selected) {
      console.warn(`⚠️ Template "${type}" not found`);
      window.showToast?.("⚠️ Template not found");
      return;
    }

    const board =
      document.getElementById("board") ||
      document.querySelector('[id*="board"]') ||
      document.querySelector('[id*="workspace"]');
    if (!board) return console.error("🚫 #board element not found.");

    console.log(`🎨 Loading template: ${selected.name || type}`);


    // --- Full layout template (replaces workspace content) ---
  if (selected.type === "layout" && selected.html) {
    // clear old tiles if function exists
    if (typeof window.clearBoard === "function") window.clearBoard();

    // insert HTML layout without nuking event listeners
    board.insertAdjacentHTML("beforeend", selected.html);

    // make it saveable like a normal tile
    if (typeof window.addTileToBoard === "function") {
      window.addTileToBoard({
        html_content: selected.html,
        title: selected.name,
        goal: "layout",
        collection: "Layouts"
      });
    }

    window.showToast?.(`✨ Loaded ${selected.name}`);
  }
    // Fallback for multi-tile templates
    else if (selected.tiles && typeof window.addTileToBoard === "function") {
      selected.tiles.forEach(t =>
        window.addTileToBoard({
          image_url: t.image_url || "",
          title: t.title || "",
          description: t.description || "",
          link: t.link || ""
        })
      );
      window.showToast?.(`✅ ${selected.tiles.length} tiles added from "${selected.name}"`);
    } else {
      console.warn(`⚠️ No tiles or HTML found in "${type}"`);
    }

    select.value = "";
  };
})();
